<template>
  <v-container fluid grid-list-xl>
    <h2>Import Paynetworx Merchant</h2>

    <v-form v-model="isFormValid" ref="form" @submit.prevent>
      <v-layout row wrap>
        <v-flex xs9 sm8>
          <v-text-field
            label="Select Entity Contact File..."
            @click="selectFile"
            v-model="file.name"
            prepend-icon="attach_file"
          ></v-text-field>

          <!-- @TODO multiple files / dragdrop -->
          <input
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ref="fileInput"
            style="display: none"
            type="file"
            @change="fileSelected"
          />
        </v-flex>

        <v-flex xs3 sm4>
          <v-btn
            class="ma-0"
            color="primary"
            @click.stop="convert"
            :disabled="!file.data"
            :loading="loading"
            >import</v-btn
          >

          <v-btn
            class="ma-0"
            color="secondary"
            @click.stop="reset"
            :disabled="!file.data"
            :loading="loading"
            >reset</v-btn
          >
        </v-flex>
      </v-layout>

      <div class="section-card">
        <h3 class="section-heading">Merchant Info</h3>
        <v-layout row wrap>
          <v-flex xs6 sm4>
            <v-text-field
              label="DBA"
              v-model="fields.name"
              box
              hide-details
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Contact"
              v-model="fields.contactName"
              box
              hide-details
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Contact Type"
              v-model="fields.type"
              box
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Address 1"
              v-model="fields.address1"
              box
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Address 2"
              v-model="fields.address2"
              box
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="City"
              v-model="fields.city"
              box
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <StateField
              v-model="fields.state"
              :textfield="fields.country !== 'USA'"
            ></StateField>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Zip"
              v-model="fields.zip"
              box
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Phone"
              v-model="fields.phone"
              box
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Email"
              v-model="fields.email"
              box
              hide-details
              required
              :rules="[rules.required, rules.isEmailValid]"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="URL"
              v-model="fields.url"
              box
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>

      <div class="section-card">
        <h3 class="section-heading">Credentials</h3>
        <v-layout row wrap>
          <v-flex xs6 sm4>
            <v-text-field
              label="Parent"
              v-model="fields.merchantParent"
              box
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="MID"
              v-model="fields.mid"
              box
              hide-details
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Token Username"
              v-model="fields.accessTokenUser"
              box
              hide-details
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field
              label="Token Password"
              v-model="fields.accessTokenPassword"
              box
              hide-details
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-select
              :items="salesReps"
              box
              label="Sales Rep"
              item-text="name"
              item-value="id"
              v-model="selectedSalesRep"
            />
            <p v-if="selectedSalesRep">
              Selected Sales Rep ID: {{ selectedSalesRep }}
            </p>
          </v-flex>
          <v-flex xs6 sm4>
            <v-autocomplete
              :items="accounts"
              box
              label="Parent Account"
              item-text="key"
              item-value="value"
              v-model="selectedParentAccount"
            />
            <p v-if="selectedParentAccount">
              Seleted Account: {{ selectedParentAccount }}
            </p>
          </v-flex>
          <v-flex xs6 sm4>
            <v-autocomplete
              :items="processors"
              box
              label="Processor Account"
              item-text="name"
              item-value="id"
              v-model="selectedProcessorAccount"
            />
            <p v-if="selectedProcessorAccount">
              Selected Processor: {{ selectedProcessorAccount }}
            </p>
          </v-flex>
        </v-layout>
      </div>

      <div class="section-card">
        <h3 class="section-heading">Terminal Type</h3>
        <v-layout row wrap>
          <v-flex xs6 sm3>
            <v-checkbox
              label="Ecom"
              value="ecom"
              v-model="fields.terminalType"
              color="primary"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3>
            <v-checkbox
              label="ACH"
              value="ach"
              v-model="fields.terminalType"
              color="primary"
              hide-details
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </div>

      <div class="section-card">
        <h3 class="section-heading">Options</h3>
        <v-layout row wrap>
          <v-flex xs6 sm4>
            <v-checkbox
              label="Cash Discount"
              v-model="fields.hasCashDiscount"
              box
              color="primary"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 sm4 v-if="fields.hasCashDiscount">
            <v-select
              label="Cash Discount Amount"
              v-model="fields.cashDiscountSchedule"
              box
              hide-details
              :items="cashDiscountSchedules"
            ></v-select>
          </v-flex>
          <v-flex xs6 sm4>
            <v-checkbox
              label="Create User"
              v-model="fields.createUser"
              box
              disabled
              color="primary"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 sm4>
            <v-checkbox
              label="Add User Reporting"
              v-model="fields.createUserReporting"
              box
              color="primary"
              disabled
              hide-details
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </div>

      <v-btn
        class="ma-0"
        color="primary"
        @click.stop="save"
        :disabled="!isFormValid"
        :loading="loading"
        >save</v-btn
      >
    </v-form>
  </v-container>
</template>

<script>
import ReadXlsxFile from 'read-excel-file'

import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import StoreMixin from '@/store/mixin'

import StateField from '@/components/forms/StateDropdown.vue'

export default {
  components: { StateField },
  mixins: [ApiMixin, AuthMixin, CashDiscountMixin, StoreMixin],

  data: function () {
    return {
      loading: false,

      isFormValid: false,

      salesReps: [],
      parentAccounts: [],
      processors: [],
      selectedSalesRep: null,
      selectedParentAccount: 3,
      selectedProcessorAccount: 6,

      file: {
        data: null,
        name: '',
        url: ''
      },

      fields: this.defaultFields(),

      rules: {
        required: value => !!value || 'Value is required',
        isEmailValid: value =>
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            value
          ) || 'Invalid email address'
      },

      parents: {},

      rows: {},

      xlsxFieldMap: {
        'Entity DBA Name': 'dba',
        'Contact Type': 'contactType',
        'Entity Contact Name': 'contactName',
        'Address 1': 'address1',
        'Address 2': 'address2',
        City: 'city',
        State: 'state',
        'Postal Code': 'postalCode',
        'Office Phone': 'phone',
        Email: 'email',
        URL: 'url'
      },

      xlsxFieldSchema: {
        'Entity DBA Name': {
          prop: 'dba',
          type: String
        },
        'Contact Type': {
          prop: 'contactType',
          type: String
        },
        'Entity Contact Name': {
          prop: 'contactName',
          type: String
        },
        'Address 1': {
          prop: 'address1',
          type: String
        },
        'Address 2': {
          prop: 'address2',
          type: String
        },
        City: {
          prop: 'city',
          type: String
        },
        State: {
          prop: 'state',
          type: String
        },
        'Postal Code': {
          prop: 'postalCode',
          type: String
        },
        'Office Phone': {
          prop: 'phone',
          type: String
        },
        Email: {
          prop: 'email',
          type: String
        },
        URL: {
          prop: 'url',
          type: String
        }
      }
    }
  },

  async mounted () {
    const salesReps = await this.getAccountSalesReps()
    this.salesReps = salesReps.data.rows

    await this.loadProcessors()
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },

    accounts () {
      const accounts = []

      for (const [key, value] of Object.entries(this.$store.state.accountMap)) {
        accounts.push({ key: key, value: value })
      }

      return accounts
    },

    cashDiscountSchedules () {
      return Object.keys(this.feeSchedule)
    }
  },

  methods: {
    defaultFields () {
      return {
        merchantParent: 'icare',
        createUser: false,
        createUserReporting: false,

        mid: '',
        tid: '',
        accessTokenUser: '',
        accessTokenPassword: '',

        name: '',
        type: '',
        contactName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: 'USA',
        phone: '',
        email: '',
        url: '',

        salesRep: '',
        parentAccount: '',
        processorAccount: '',

        hasCashDiscount: false,
        cashDiscountSchedule: '',

        terminalType: ['ecom']
      }
    },

    async getAccountSalesReps () {
      let result = await this.api({
        method: 'get',
        url: '/users',
        params: {
          filter: {
            position: 'Account Rep'
          }
        }
      })
      return result
    },

    async loadProcessors () {
      try {
        let data = await this.api({ url: '/processors/list' })
        this.processors = data.data.rows
      } catch (error) {
        console.error('Error loading processors:', error)
      }
    },

    selectFile () {
      this.$refs.fileInput.click()
    },

    fileSelected (event) {
      this.loading = true

      const files = event.target.files
      if (files[0] !== undefined) {
        this.file.name = files[0].name

        if (this.file.name.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file.url = fr.result
          this.file.data = files[0]
        })
      } else {
        this.file.name = ''
        this.file.data = null
        this.file.url = ''
      }

      this.loading = false
    },

    reset () {
      this.file.name = ''
      this.file.data = null
      this.file.url = ''
      this.fields = this.defaultFields()
      this.$refs.fileInput.value = ''
      this.$refs.form.resetValidation()
    },

    convert () {
      this.loading = true

      ReadXlsxFile(this.file.data, { schema: this.xlsxFieldSchema }).then(
        ({ rows, errors }) => {
          this.rows = rows

          let location = rows.find(field => field.contactType === 'Owner')

          if (typeof location === 'undefined') {
            location = rows[0]
          }

          if (typeof location === 'object' && Object.keys(location).length) {
            this.fields.name = location.dba
            this.fields.type = location.contactType
            this.fields.contactName = location.contactName
            this.fields.address1 = location.address1
            this.fields.address2 = location.address2
            this.fields.city = location.city
            this.fields.state = location.state
            this.fields.zip = location.postalCode
            this.fields.phone = location.phone
            this.fields.email = location.email.toLowerCase()
            this.fields.url = location.url.toLowerCase()
          }
        }
      )

      this.loading = false
    },

    async save () {
      Bus.$emit('openWaitModal')

      try {
        if (!this.$refs.form.validate()) {
          let errors = []
          this.$refs.form.inputs.forEach(e => {
            if (e.hasError) {
              errors.push(e.errorBucket[0])
            }
          })

          let message = 'Validation Error'

          if (errors.length > 1) {
            message = 'Validation Errors'
          }

          Bus.$emit('openModal', {
            status: 'error',
            message: message,
            messageDetails: errors
          })

          return false
        }

        if (this.selectedSalesRep) {
          this.fields.salesRep = this.selectedSalesRep.toString()
        }

        if (this.selectedParentAccount) {
          this.fields.parentAccount = this.selectedParentAccount.toString()
        }

        if (this.selectedProcessorAccount) {
          this.fields.processorAccount = this.selectedProcessorAccount.toString()
        }

        let result = await this.api({
          method: 'post',
          url: `/paynetworx_accounts`,
          data: this.fields
        })

        const tidLines = result.data.data.tid.map(t => `TID (${t.terminal_type}): ${t.terminal_code}`)
        Bus.$emit('openModal', {
          message: 'Saved',
          messageDetails: [
            `MID: ${result.data.data.mid}`,
            ...tidLines
          ]
        })
      } catch (err) {
        Bus.$emit('closeWaitModal')
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>

<style>
#decoded {
  height: 100%;
  resize: both;
  overflow: auto;
}
.section-card {
  margin-bottom: 16px;
}
.section-heading {
  background-color: #e8f4fb;
  color: var(--v-primary-base);
  padding: 12px 16px;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/paynetworx/ImportMerchant.vue